var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLaptops = function SvgIconLaptops(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.325 9.75C18.325 10.6438 17.5833 11.375 16.6667 11.375H20V13H0V11.375H3.33333C2.40833 11.375 1.66667 10.6438 1.66667 9.75V1.625C1.66667 0.723125 2.40833 0 3.33333 0H16.6667C17.5833 0 18.3333 0.723125 18.3333 1.625L18.325 9.75ZM3.33333 1.625V9.75L16.6667 9.75813V1.625H3.33333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 4.0625C11.6667 4.9595 10.92 5.6875 10 5.6875C9.08 5.6875 8.33333 4.9595 8.33333 4.0625C8.33333 3.1655 9.08 2.4375 10 2.4375C10.92 2.4375 11.6667 3.1655 11.6667 4.0625ZM10.8333 4.0625C10.8333 4.511 10.46 4.875 10 4.875C9.54 4.875 9.16667 4.511 9.16667 4.0625C9.16667 3.614 9.54 3.25 10 3.25C10.46 3.25 10.8333 3.614 10.8333 4.0625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.33749C11.1267 6.33749 13.3333 6.92249 13.3333 8.28099V8.93749H6.66667V8.28099C6.66667 6.92249 8.87333 6.33749 10 6.33749ZM10 7.3125C9.22666 7.3125 8.28 7.6245 7.87333 7.9625H12.1333C11.7267 7.6245 10.78 7.3125 10 7.3125Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLaptops, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_laptops.788fe450.svg";
export { ForwardRef as ReactComponent };